import Page from '../../../components/page.vue'
import {api, getHallCode} from "../../../common/config";
import {store} from '../../../store/store.js';
import Select from '../../../components/select.vue'
import search from '../../../components/search.vue'
import searchIndex from '../../../components/searchIndex.vue'
import book from '../../../components/book.vue'
import library from '../../../components/library.vue'
import zixun from '../../../components/zixun.vue'
import activity from '../../../components/activity.vue'
import {ajaxUtil} from '../../../common/AjaxUtil.js';
import {CommonUtil} from '../../../common/CommonUtil.js';
import {StorageUtil, LocalStorageUtil} from '../../../common/Auth.js';

export default {
  name: 'bookList',
  components: {
    Page,
    Select,
    search,
    book,
    library,
    zixun,
    activity,
    searchIndex
  },
  data() {
    return {
      fromSearch: 0, /*0:首页 1其余页面*/
      webType: store.webType, /*0:平台1：图书馆*/
      imgError: store.imgError,
      paramsListBook: {
        keyword: '',
        categoryId: '',
        categoryDesc: '',
        isbn: '',
        bookName: '',
        author: '',
        publisher: '',
        publishDate: '',
      },
      paramsListLibrary: {
        keyword: '',
        area: '',
        areaStrs: '',
        level: '',
        libCode: '',
        libName: '',
      },
      paramsListNews: {
        keyword: '',
        categoryDesc: '',
        industryDesc: '',
        source: '',
        title: '',
        category: '',
        industry: '',
      },
      params: '',
      keywordInput: '',
      pageNo: 1,
      pageCount: 12,
      listObj: [],
      ajaxStatus: false,
      totalPage: 1,
      searchResult: '',
      type: -1, /*1:图书，2：电子书，3，图书馆，4活动，5：资讯*/
      select: {desc: '图书'},
      totalCount: 0,
      totalBooks: 0,
      searchKeyStr: "",
      hallCode: '',
      libCode: '',
      lngLat: store.localtionArea.latLng,
      locationCode: '510107',
      idS: [],//id数组
    }
  },
  watch: {
    $route() {
      this.queryData()
    }
  },
  beforeMount() {
    this.queryData()
  },

  beforeRouteEnter(to, from, next) {
    if (from.path == '/library') {
      store.wrap.activeRouteName = '图书馆'
    }
    next()
  },
  mounted() {
      store.chooseArea=StorageUtil.getObject("chooseArea");
      CommonUtil.changeExpiredCode(this, store);
  },
  methods: {
    queryData() {
      this.paramsListBook = {
        keyword: this.$route.query.searchStr || '',
        categoryId: this.$route.query.categoryId || '',
        categoryDesc: this.$route.query.categoryDesc || '',
        isbn: this.$route.query.isbn || '',
        bookName: this.$route.query.name || '',
        author: this.$route.query.author || '',
        publisher: this.$route.query.publisher || '',
        publishDate: this.$route.query.publishDate || '',
      };
      this.paramsListLibrary = {
        keyword: this.$route.query.searchStr || '',
        area: this.$route.query.area || '',
        areaStrs: this.$route.query.areaStrs || '',
        level: this.$route.query.level || '',
        libCode: this.$route.query.libCode || '',
        libName: this.$route.query.libName || '',
      };
      this.paramsListNews = {
        keyword: this.$route.query.searchStr || '',
        categoryDesc: this.$route.query.categoryDesc || '',
        industryDesc: this.$route.query.industryDesc || '',
        source: this.$route.query.source || '',
        title: this.$route.query.title || '',
        category: this.$route.query.category || '',
        industry: this.$route.query.industry || '',
      };

      this.keywordInput = this.$route.query.searchStr || '';
      this.pageNo = this.$route.query.page || 1;
      this.type = this.$route.query.type || -1;
      this.libCode = this.$route.query.libCode || '';
      this.hallCode = this.$route.query.hallCode || ''; //图书馆网站参数
      this.fromSearch = this.$route.query.fromSearch || '';
      this.lngLat = this.$route.query.latLng || store.localtionArea.latLng;
      this.locationCode = this.$route.query.code || "510107";
      this.idS = [];
      if (this.paramsListLibrary.level == "全部") {
        this.paramsListLibrary.level = "";
      }
       var oneLevelCategoryId=this.$route.query.oneLevelCategoryId || '';
       var twoLevelCategoryId=this.$route.query.twoLevelCategoryId || '';
      if(twoLevelCategoryId!=""){
          this.paramsListBook.twoLevelCategoryId=twoLevelCategoryId;
      }else if(oneLevelCategoryId!=""){
          this.paramsListBook.oneLevelCategoryId=oneLevelCategoryId;
      }
      /**
       * 组装 searchResult 的结果
       */
      var objList = new Object();
      if (this.type == 1 || this.type == 2) {
        objList = this.paramsListBook;
      } else if (this.type == 3) {
        objList = this.paramsListLibrary;
      } else if (this.type == 5) {
        objList = this.paramsListNews;
      } else {
        objList = {
          searchStr: this.$route.query.searchStr || ''
        }
      }
      var flag = false;
      this.searchKeyStr = '';
      this.params = '';
      for (var key in objList) {
        if (objList[key]) {
          this.params += `&${key}=${objList[key]}`;
        }
        if (`${key}` != 'categoryId' && `${key}` != 'area' && `${key}` != 'category' && `${key}` != 'industry'
            && `${key}` != 'oneLevelCategoryId'  && `${key}` != 'twoLevelCategoryId') {
          var searchKey = `${objList[key]}`;
          if (searchKey != "") {
            if (searchKey != "全部") {
              flag = true;
              this.searchKeyStr += "\"" + searchKey + "\"，";
            }
          }
        }
      }
      if (this.params != "") {
        if (!flag) {
          this.searchKeyStr = "\"" + "全部" + "\",";
        }
      } else {
        this.searchKeyStr = "\"" + "全部" + "\",";
      }
      this.searchKeyStr = this.searchKeyStr.substr(0, this.searchKeyStr.length - 1);

      /**
       * 请求数据
       */
      var urlTitle = "";
      if (this.type == 1) {
        urlTitle = api.book.search;
        this.select = {desc: '图书'};
      } else if (this.type == 2) {
        urlTitle = api.ebook.search;
        this.select = {desc: '电子书'};
      } else if (this.type == 3) {
        urlTitle = api.library.list;
        this.select = {desc: '图书馆'};
      } else if (this.type == 4) {
        this.select = {desc: '活动'};
        this.pageCount = 4;
        if (this.libCode!='' || this.hallCode!='') {
          urlTitle = api.activity.activitys;
        } else {
          urlTitle = api.activity.search;
        }
      } else if (this.type == 5) {
        this.select = {desc: '资讯'};
        this.pageCount = 4;
        if (this.libCode !='' || this.hallCode!='') {
          urlTitle = api.library.libNews;
        } else {
          urlTitle = api.information.search;
        }
      }
      var hcod = this.hallCode != null && this.hallCode != '' ? this.hallCode : this.libCode;
      var codeVar = "";
        if (this.libCode !=null && this.params.indexOf('&libCode=')== -1) {
        codeVar = '&libCode=' + hcod;
      }
      var url = urlTitle.replace('{libCode}', this.hallCode).replace('{pageNo}', this.pageNo).replace('{pageCount}', this.pageCount)
      .replace('{locationCode}', this.locationCode).replace('{lngLat}', this.lngLat)
      .replace('{keyword}', this.keywordInput) + codeVar + this.params /*+ libCodeParam*/;
      this.listObj = [];
      this.ajaxStatus = true;
      this.totalCount = 0;
      this.totalBooks = 0;
      this.totalPage = 1;
      this.pageNo = 1;
      this.pageCount = 12;
      ajaxUtil.ajaxJson(url, null, "GET", (data) => {
        this.pageNo = data.pageNo;
        this.listObj = data.resultList;
        this.ajaxStatus = false;
        this.totalCount = data.totalCount;
        this.totalPage = data.totalPage ? data.totalPage : Math.ceil(data.totalCount / this.pageCount);
        if (this.type == 5) {
          for (var i = 0; i < data.resultList.length; i++) {
            this.idS.push(data.resultList[i].newsId);
          }
        };
        if (this.type == 4) {
          for (var i = 0; i < data.resultList.length; i++) {
            this.idS.push(data.resultList[i].id);
          }
        }
      }, null, this);

      var list = ['图书', '电子书', '图书馆', '活动', '资讯']
      if (this.fromSearch == 0) {
        store.wrap.activeRouteName = '首页'
      } else {
        if (store.wrap.activeRouteName != '图书馆') {
          store.wrap.activeRouteName = list[this.type - 1]
        }
      }
    },
    highSearch: function (select) {
      //1:图书，2：电子书，3，图书馆，4活动，5：资讯*/
      var searchType = select ? select.type : this.$route.query.type;
      if (searchType == 1) {
        this.$router.push({
          path: '/searchbook',
          query: {type: 1, "fromSearch": this.$route.query.fromSearch, hallCode: this.hallCode, typeId:0 }
        });
      } else if (searchType == 2) {
        this.$router.push({
          path: '/searchbook',
          query: {type: 1, "fromSearch": this.$route.query.fromSearch, hallCode: this.hallCode, typeId:1 }
        });
      } else if (searchType == 3) {
        this.$router.push({
          path: '/searchlibrary',
          query: {type: 1, "fromSearch": this.$route.query.fromSearch, hallCode: this.hallCode}
        });
      } else if (searchType == 5) {
        this.$router.push({
          path: '/searchbook',
          query: {type: 1, "fromSearch": this.$route.query.fromSearch, hallCode: this.hallCode, typeId:2 }
        });
      }
    },

    /*
     * (普通/高级搜索)
     * */
    getBooks(pageNo) {
      CommonUtil.mergeQuery(this, {page: pageNo})
    },
    //点击搜索
    search(keywordInput, select) {
      var searchStr = keywordInput.trim();
      if (searchStr == "") {
        if (this.webType === 1) {
          this.$router.push('/?hallCode=' + this.hallCode);
        } else {
          this.$router.push('/');
        }
        return;
      };

      let libCode = "";
      if (this.webType === 1) {
        libCode = this.libCode;
      };
      CommonUtil.mergeQueryClean(this, {
        "searchStr": searchStr, "type": select ? select.type : this.type, "code": store.chooseArea.code,
        "fromSearch": this.$route.query.fromSearch, "libCode": libCode, "hallCode": this.hallCode
      });
    },
    //详情页
    toBookInfo(item) {
      if (this.type == 1) {
        this.$router.push({path: 'bookinfo', query: {isbn: item.isbn}});
      } else {
        this.$router.push({path: 'ebookinfo', query: {id: item.id}});
      }
    },
    toLibraryInfo(libId, libCode, libName, libLevel, websiteUrl) {
      if (websiteUrl != null && websiteUrl.trim() != "") {
        window.open(websiteUrl);
        return;
      }
      CommonUtil.storePrevList();
      this.$router.push({
        path: 'libraryInfo',
        query: {libId: libId, fromSearch: 0, libCode: libCode, libName: libName, libLevel: libLevel}
      });
    },
    //资讯
    toNewsInfo(newsId, type) {
      var data = {
        ids: this.idS,
        totalCount: this.totalCount,
        pageNo: this.pageNo,
        totalPage: this.totalPage,
        pageCount: this.pageCount,
      };
      StorageUtil.storeObject("informationInfo", data);
      this.$router.push({path: 'infordetails', query: {newsId: newsId, fromSearch: 0}});
    },
    //活动
    toActivityInfo(id,type) {
      var data = {
        ids: this.idS,
        totalCount: this.totalCount,
        pageCount: this.pageCount,
        pageNo: this.pageNo,
        totalPage: this.totalPage
      };
      StorageUtil.storeObject("activityInfo", data);
      this.$router.push({path: 'activitydetails', query: {activityId: id}});
    },
    returnUrlTitle() {
      var urlTitle = "";
      if (this.select.desc == '图书') {
        urlTitle = api.book.search;
      } else if (this.select.desc == '电子书') {
        urlTitle = api.ebook.search;
      } else if (this.select.desc == '图书馆') {
        urlTitle = api.library.list;
      } else if (this.select.desc == '资讯') {
        urlTitle = api.information.search;
      } else if (this.select.desc == '活动') {
        urlTitle = api.activity.search;
      }
      return urlTitle;
    },
    getParams() {
      this.params = "";
      var objList = new Object();
      if (this.select.desc == '图书' || this.select.desc == '电子书') {
        objList = this.paramsListBook;
      } else if (this.select.desc == '图书馆') {
        objList = this.paramsListLibrary;
      }
      for (var key in objList) {
        this.params += `&${key}=${objList[key]}`
      }
    },

    initParams() {
      //this.listObj=[];
      if (this.select.desc == '图书' || this.select.desc == '电子书') {
        for (var key in this.paramsListBook) {
          this.paramsListBook[key] = ''
        }
      } else if (this.select.desc == '图书馆') {
        for (var key in this.paramsListLibrary) {
          this.paramsListLibrary[key] = ''
        }
      }
    },
  }
}
